import { styled } from '@material-ui/core';

import { Typography } from 'shared/components/typography/Typography';

export const Header = styled(Typography)(({ theme: { breakpoints } }) => ({
  [breakpoints.down('sm')]: {
    fontSize: 34,
  },
}));
